import script from "./QrScanPage.vue?vue&type=script&setup=true&lang=js"
export * from "./QrScanPage.vue?vue&type=script&setup=true&lang=js"

import "./QrScanPage.vue?vue&type=style&index=0&id=2c51c3bc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c51c3bc"]])

export default __exports__